import Vue from "vue";
import VueRouter from "vue-router";
import { getNarrativeComplete } from "../localStorage";
import ContactSheet from "../views/ContactSheet.vue";
import MapView from "../views/MapView.vue";
import NarrativeView from "../views/NarrativeView.vue";
import ImageView from "../views/ImageView.vue";
import About from "../views/About";
import Passthrough from "../views/Passthrough";
import { DEFAULT_YEAR } from "../constants/constants";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: () => {
      if (getNarrativeComplete()) {
        return "map/" + DEFAULT_YEAR;
      }
      return "map/narrative";
    }
  },
  {
    path: "/map",
    component: MapView,
    children: [
      {
        path: "narrative",
        component: NarrativeView,
        name: "narrative"
      },
      {
        path: ":year",
        name: "map",
        component: Passthrough,
        children: [
          {
            name: "MapModal",
            path: "image/:image",
            component: ImageView
          }
        ]
      }
    ]
  },
  {
    path: "/contact-sheet",
    name: "contact-sheet",
    component: ContactSheet,
    children: [
      {
        name: "ContactSheetModal",
        path: "image/:image",
        component: ImageView
      }
    ]
  },
  {
    path: "/about",
    name: "about",
    component: About
  }
];

const router = new VueRouter({
  mode: process.env.VUE_APP_ROUTER_MODE,
  routes
});

export default router;
